export default "__VITE_ASSET__Ps8NB02z__"